import React, { createContext, useContext, useEffect, useCallback } from 'react';
import config from '../config';

const CssContext = createContext();

export const useCss = () => useContext(CssContext);

export const CssProvider = ({ children }) => {

  // CSS verilerini API'den al ve uygula
  const fetchAndApplyCss = useCallback(async () => {
    try {
      console.log('🎨 CSS verileri API\'den yükleniyor...');
      
      // Güvenlik kontrolleri
      if (!window.rh || !window.rh.cr) {
        console.warn('⚠️ Güvenlik sistemi yüklenmemiş, default CSS kullanılıyor');
        applyDefaultCss();
        return;
      }

      const payload = JSON.stringify({
        process_id: "get-css",
        user_id: "",
      });

      const keys = await window.rh.cr(payload);
      
      const response = await fetch(
        `${config.apiBaseUrl}`,
        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "hk": keys[0],
            "hh": keys[1]
          },
          body: payload,
        }
      );

      if (!response.ok) {
        console.warn('⚠️ CSS API isteği başarısız, default CSS kullanılıyor');
        applyDefaultCss();
        return;
      }

      const result = await response.json();
      
      // API response formatına göre CSS verilerini al
      let cssData = result;
      
      // Eğer result.status varsa ve başarılıysa data field'ını kullan
      if (result.status && result.data) {
        cssData = result.data;
      } else if (result.status === false) {
        console.warn('⚠️ CSS API hatası:', result.message || 'Bilinmeyen hata', '- Default CSS kullanılıyor');
        applyDefaultCss();
        return;
      }
      
      // CSS verilerini kontrol et ve uygula
      if (cssData && typeof cssData === 'object' && Object.keys(cssData).length > 0) {
        console.log('✅ CSS verileri API\'den alındı:', Object.keys(cssData).length, 'özellik');
        
        // CSS custom properties olarak uygula
        Object.entries(cssData).forEach(([cssVar, value]) => {
          if (cssVar.startsWith('--') && value) {
            document.documentElement.style.setProperty(cssVar, value);
          }
        });

        // Tema manager'a sync et
        if (window.themeManager && window.themeManager.syncFromApi) {
          window.themeManager.syncFromApi(cssData);
          console.log('✅ CSS verileri tema manager\'a sync edildi');
        }
      } else {
        console.warn('⚠️ Geçersiz CSS verisi, default CSS kullanılıyor');
        applyDefaultCss();
      }

    } catch (error) {
      console.error('❌ CSS yükleme hatası:', error);
      console.warn('⚠️ Default CSS kullanılıyor');
      applyDefaultCss();
    }
  }, []);

  // Default CSS değerlerini uygula (API başarısız olursa)
  const applyDefaultCss = useCallback(() => {
    console.log('🎨 Default CSS değerleri uygulanıyor...');
    
    // Tema manager'a null göndererek default değerleri uygulamasını sağla
    if (window.themeManager && window.themeManager.syncFromApi) {
      window.themeManager.syncFromApi(null);
      console.log('✅ Default CSS değerleri tema manager aracılığıyla uygulandı');
    } else {
      // Tema manager henüz hazır değilse, bir süre sonra tekrar dene
      setTimeout(() => {
        if (window.themeManager && window.themeManager.syncFromApi) {
          window.themeManager.syncFromApi(null);
          console.log('✅ Default CSS değerleri tema manager aracılığıyla uygulandı (gecikme ile)');
        }
      }, 100);
    }
  }, []);

  // Uygulama açılırken CSS'i yükle
  useEffect(() => {
    fetchAndApplyCss();
  }, [fetchAndApplyCss]);

  return (
    <CssContext.Provider value={{ fetchAndApplyCss }}>
      {children}
    </CssContext.Provider>
  );
}; 